
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PreviewCollectionField extends Vue {
  @Prop()
  readonly label!: string;

  @Prop()
  readonly value!: any

  @Prop()
  readonly name!: string;

  get collectionItems(): any[] {
    const itemsObject = this.value?.items;
    if (Array.isArray(this.value)) {
      return this.value;
    }
    if (itemsObject) {
      const collectionKey = Object.keys(itemsObject)[0];
      return this.value?.items[collectionKey] || [];
    }
    return [];
  }

  get headers() {
    const item = this.collectionItems[0];
    if (item) {
      const headerKeys = Object.keys(item);
      /* TODO брать локализацию из макета fieldCollections вместо vue-i18n */
      return headerKeys.map((key) => ({
        text: this.$t(key),
        value: key,
      }));
    }
    return [];
  }
}
